(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-custom-product-quantity"] && !Shopify.designMode) return;
  try {
    class CustomProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.activeSelectorName = this.querySelector('[data-active-selector-name]');
    this.customProductQuantityInput = this.querySelectorAll('[name="custom_quantity"]');
    }

    connectedCallback() {
      this.customProductQuantityInput.forEach((item) => {
        item.addEventListener('change', () => {
          console.log('item', item);
          const selectorName = item.dataset.selectorName;
          console.log('selectorName', selectorName);
          this.activeSelectorName.textContent = selectorName;
        });
      });
    }

    disconnectedCallback() {
      this.customProductQuantityInput.forEach((item) => {
        item.removeEventListener('change', () => {
          const selectorName = item.dataset.selectorName;
          this.activeSelectorName.textContent = selectorName;
        });
      });
    }
  }
  customElements.define('custom-product-quantity', CustomProductQuantity);
  } catch(e) { console.error(e); }
})();

})();
